import React, {useState, useEffect} from 'react';
import axios from 'axios';
import AdminMenu from "../AdminMenu";
import AdminHeader from "../AdminHeader";
import Button from "../../../components/elements/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import InputField from "../../../components/elements/InputField";
import {useNavigate, useParams} from 'react-router-dom';
import ErrorMessage from "../../../components/layout/ErrorMessage";
import {ADMIN_API_BASE} from "../../../utils/apiConfig";
import TextEditor from "../../../components/elements/TextEditor";

const AdminGlossaryPage = () => {
    const [cheatsheet, setCheatsheet] = useState({
        title: '',
        subtitle: '',
        courseId: '',
        content: [],
    });

    // const [initialId, setInitialId] = useParams();
    const [cheatsheetId, setCheatsheetId] = useState(null);

    const [message, setMessage] = useState("");

    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    useEffect(() => {

        const fetchCheatsheet = async (idToFetch) => {
            if (!idToFetch) {
                return;
            }
            try {
                const token = await getCsrfToken();

                const response = await axios.get(`${ADMIN_API_BASE}/cheatsheet/${idToFetch}`, {
                    withCredentials: true,
                    headers: {
                        'csrf-token': token,
                    },
                });
                if (response.data && response.data.draft) {
                    setCheatsheet(response.data);
                    setCheatsheetId(idToFetch);
                } else {
                    console.error("Draft not found or invalid response");
                    setMessage({type: 'error', text: 'Draft not found.'});
                }
            } catch (error) {
                console.error("Error fetching draft:", error);
                setMessage({type: 'error', text: 'Error fetching draft: ' + error.message});
            }
        };

        // if (initialId) {
        //     fetchCheatsheet(initialId);
        // }

    });
    // }, [initialId]);

    const handleInputChange = (e) => {
        const {name, value} = e.target;

        setCheatsheet((prevCheatsheet) => ({...prevCheatsheet, [name]: value}));
    };

    const updateCheatsheet = async () => {
        const formData = new FormData();
        formData.append("title", cheatsheet.title);
        formData.append("subtitle", cheatsheet.subtitle);
        formData.append("content", cheatsheet.content);

        try {
            const token = await getCsrfToken();

            let response;

            if (cheatsheetId) {
                response = await axios.put(`${ADMIN_API_BASE}/cheatsheet/${cheatsheetId}`, formData, {
                    headers: {
                        'csrf-token': token, // Get it from res.locals or inject via API
                    },
                    withCredentials: true // Keep session cookies
                });
            }

            setMessage({type: "success", text: "cheatsheet updated successfully!"});
        } catch (error) {
            setMessage({type: "error", text: "err: " + (error.response?.data?.error || error.message)});
        }
    };

    const fetchUpdatedCheatsheet = async (course_id, id) => {
        try {
            const token = await getCsrfToken();

            const res = await axios.get(`${ADMIN_API_BASE}/cheatsheet/${course_id}/${id}`, {
                withCredentials: true,
                headers: {
                    'csrf-token': token, // Get it from res.locals or inject via API
                },
            });
            if (res.data && res.data) {
                setCheatsheet(res.data);
            }
        } catch (error) {
        }
    };


    return (
        <div className="flex flex-1">
            <div className="flex flex-1">
                <div className='w-1/5'>
                    <AdminMenu path='./'/>
                </div>
                <div className='flex-grow relative w-4/5'>
                    {/*<AdminHeader title={` دیکشنری ${initialId}`}/>*/}
                    {message.text && <ErrorMessage type={message.type} message={message.text}/>}
                    <form encType='multipart/form-data' className='px-8 py-5' onSubmit={(e) => e.preventDefault()}>
                        <div className='flex justify-end'>
                            <Button className='p-1 bg-light-primary text-white'
                                    onClick={() => updateCheatsheet()}>
                                <FontAwesomeIcon icon={faSave} className='h-4'/> ذخیره
                            </Button>
                        </div>
                        <div className='w-1/2'>
                            <InputField name='courseId' title='course_id' disabled={true} type='text' value={cheatsheet.courseId || ''} />
                        </div>
                        <div className='w-1/2'>
                            <InputField name='title' title='تیتر' type='text' value={cheatsheet.title || ''}
                                        onChange={handleInputChange}/>
                        </div>
                        <div className='w-1/2'>
                            <InputField name='subtitle' title='زیرتیتر' type='text' value={cheatsheet.subtitle || ''}
                                        onChange={handleInputChange}/>
                        </div>
                        <div className='w-full'>
                            <TextEditor value={cheatsheet.content} onChange={updateCheatsheet}/>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminGlossaryPage;